import React from 'react';
import { getTrans } from '../../Utils/translate';
import { Button } from './button';
import './button-bar.scss';

const ButtonBar = ({ buttons, onClick }) => {
  let activeButton = 1;
  buttons.forEach(({ active }, index) => {
    if (active) activeButton = index + 1;
  });
  return (
    <nav className="buttonBar appRow">
      <div
        className="background"
        data-active={activeButton}
        style={{ left: activeButton === 1 ? 4 : '50%' }}
      />
      {buttons &&
        buttons.map((button, index) => (
          <Button
            key={`${index}-${button.text}`}
            active={button.active}
            onClick={() => onClick(index)}>
            {getTrans(button.text) || button.text}
          </Button>
        ))}
    </nav>
  );
};

export { ButtonBar };
